/**
 * (c) Copyright Swisscom (Schweiz) AG. All rights reserved.
 *
 * This product is the proprietary and sole property of Swisscom (Schweiz) AG
 * Use, duplication or dissemination is subject to prior written consent of
 * Swisscom (Schweiz) AG.
 *
 * $Id: faq.js
 */
$.namespace("SCS.faq");

SCS.faq.firstPageLoaded = false;
SCS.faq.gsaFirstPageLoaded = false;

/**
 * Initialize FAQ
 */
SCS.faq.init = function(resultPerPage, numResults) {

	$(window).on('hashchange', function() {
		SCS.faq.switchPage(location.hash, resultPerPage, numResults);
	});
	$(window).trigger('hashchange');
};

/**
 * Switch FAQ results page (Solution results)
 * @param hash Hash/Anchor (#)
 */
SCS.faq.switchPage = function(hash, resultPerPage, numResults) {
	var hashPrefix = "#p-";
	if (hash.startsWith(hashPrefix) || !this.firstPageLoaded) {
		var pageNumber = (hash && hash.startsWith(hashPrefix)) ? hash.substr(hashPrefix.length)
			: "1";

		// show/hide results page
		var resultsSelector = '.faqPage';
		var selectedResultId = 'faqPage-' + pageNumber;
		$(resultsSelector).each(function() {
			if (this.id == selectedResultId) {
				$(this).show();
			} else {
				$(this).hide();
			}
		});

		// switch page link
		this.switchPageLink('page', pageNumber, numResults, resultPerPage);

		// change start/end number text
		var startIndex = ((pageNumber - 1) * resultPerPage) + 1;
		$('#jcrFaqStartIndex').html(startIndex);

		var endIndex = 0;
		if (numResults > resultPerPage) {
			var endI = pageNumber * resultPerPage;
			if (endI > numResults) {
				endIndex = numResults;
			} else {
				endIndex = endI;
			}
		} else {
			endIndex = numResults;
		}
		$('#jcrFaqEndIndex').html(endIndex);

		this.firstPageLoaded = true;
	}
};

/**
 * Switch highlighting of page links
 * @param cssPrefix CSS prefix
 */
SCS.faq.switchPageLink = function(cssPrefix, pageNumber, numResults, resultPerPage) {
	var indexCounter = Math.ceil(parseInt(numResults) / parseInt(resultPerPage));

	if (indexCounter > 10) {
		for ( var i = 1; i <= indexCounter; i++) {
			$("#pageLink-" + i + "-counter").hide();
			$("#pageLink-" + i + "-counter").removeClass("active");
		}

		if (1 <= pageNumber && pageNumber < 7) {

			for ( var i = 0; i <= 7; i++) {
				$("#pageLink-" + i + "-counter").show();
			}

			$("#pageLink-" + parseInt(indexCounter - 1) + "-counter").show();
			$("#pageLink-" + indexCounter + "-counter").show();
			$("#pageLink-" + pageNumber + "-counter").addClass("active");
			$("#lastSpan").show();
			$("#firstSpan").hide();
		} else if (indexCounter - 7 < pageNumber && pageNumber <= indexCounter) {
			for ( var i = 0; i <= 7; i++) {
				$("#pageLink-" + parseInt(indexCounter - i) + "-counter").show();
			}
			$("#pageLink-" + 1 + "-counter").show();
			$("#pageLink-" + 2 + "-counter").show();
			$("#pageLink-" + pageNumber + "-counter").addClass("active");
			$("#firstSpan").show();
			$("#lastSpan").hide();
		} else {
			$("#pageLink-" + 1 + "-counter").show();
			$("#pageLink-" + 2 + "-counter").show();

			$("#pageLink-" + parseInt(pageNumber - 1) + "-counter").show();
			$("#pageLink-" + parseInt(pageNumber - 2) + "-counter").show();
			$("#pageLink-" + pageNumber + "-counter").addClass("active");
			$("#pageLink-" + pageNumber + "-counter").show();

			var next1 = parseInt(pageNumber) + 1;
			var next2 = parseInt(pageNumber) + 2;

			$("#pageLink-" + next1 + "-counter").show();
			$("#pageLink-" + next2 + "-counter").show();

			$("#pageLink-" + parseInt(indexCounter - 1) + "-counter").show();
			$("#pageLink-" + indexCounter + "-counter").show();

			$("#firstSpan").show();
			$("#lastSpan").show();
		}
	}

	else {

		var pageLinksSelector = '.' + cssPrefix + 'link';
		var selectedPageId = cssPrefix + 'Link-' + pageNumber + '-counter';
		$(pageLinksSelector).each(function() {
			if (this.id == selectedPageId) {
				$(this).addClass("active");
			} else {
				$(this).removeClass("active");
			}
		});
	}

	var startIndex = ((pageNumber - 1) * resultPerPage) + 1;
	if (numResults >= startIndex + resultPerPage) {
		var next = parseInt(pageNumber) + 1;
		$('#pageLinkNext').attr("href", "#p-" + next);
		$('#pageLinkNext').show();
	} else {
		$('#pageLinkNext').hide();
	}
	if (startIndex - resultPerPage > 0) {
		var prev = parseInt(pageNumber) - 1;
		$('#pageLinkPrevious').attr("href", "#p-" + prev);
		$('#pageLinkPrevious').show();
	} else {
		$('#pageLinkPrevious').hide();
	}
};

SCS.faq.sendRequest = function() {
	var searchBoxElement = $("#searchHidden");
	searchBoxElement.val(escape($("#search").val()));
};

SCS.faq.setText = function(query) {
	var searchBoxElement = $("#search");
	if ($("#searchHidden").val() != null) {
		searchBoxElement.val(unescape(query));
	}
};



//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/help/clientlibs/desktop/js/faq.js
// module id = 335
// module chunks = 0